import React from 'react';
import { fc, mk, moIncome } from '../../utils';

export function YearToDateCard({ state }) {
  const now = new Date();
  const year = now.getFullYear();
  const curMonth = now.getMonth();

  let ytdEarned = 0, ytdSaved = 0, ytdSpent = 0, ytdBills = 0;

  for (let m = 0; m <= curMonth; m++) {
    const key = mk(year, m);
    ytdEarned += moIncome(state.incomeLog, key);
    ytdSaved += ((state.savLog || {})[key] || []).reduce((s, e) => s + (e.amt || 0), 0);
    const vs = (state.varSpend || {})[key] || {};
    ytdSpent += Object.values(vs).flat().reduce((s, e) => s + (e.amt || 0), 0);
    const paid = (state.paidBills || {})[`${year}-${m}`] || {};
    const allB = [
      ...(state.fixedBills || []),
      ...(state.cards || []).map((c) => ({ id: c.id, amt: c.min || 0 })),
      ...(state.subscriptions || []).filter((s) => s.cycle !== 'annual'),
    ];
    ytdBills += allB.reduce((s, b) => s + (paid[b.id] ? b.amt || 0 : 0), 0);
  }

  if (ytdEarned === 0 && ytdSpent === 0) return null;

  const savRate = ytdEarned > 0 ? Math.round((ytdSaved / ytdEarned) * 100) : 0;
  const MO = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  return (
    <div className="card cp" style={{ marginBottom: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 12 }}>
        <div className="st" style={{ marginBottom: 0 }}>📅 Year to Date — {year}</div>
        <span style={{ fontSize: 10, color: 'var(--mut)' }}>Jan – {MO[curMonth]}</span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 8 }}>
        {[
          { em: '💰', label: 'Earned', val: fc(ytdEarned), col: 'var(--grn)' },
          { em: '🛒', label: 'Spent', val: fc(ytdSpent + ytdBills), col: 'var(--red)' },
          { em: '💵', label: 'Saved', val: fc(ytdSaved), col: 'var(--blu)' },
          { em: '📈', label: 'Savings Rate', val: savRate + '%', col: savRate >= 20 ? 'var(--grn)' : savRate >= 10 ? 'var(--ylw)' : 'var(--red)' },
        ].map((s) => (
          <div key={s.label} style={{ padding: '10px 12px', background: 'var(--surf2)', borderRadius: 10, border: '1px solid var(--bdr)', borderLeft: `3px solid ${s.col}` }}>
            <div style={{ fontSize: 10, color: 'var(--mut)', marginBottom: 3, fontWeight: 600 }}>{s.em} {s.label}</div>
            <div style={{ fontSize: 18, fontWeight: 900, color: s.col }}>{s.val}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
